import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
  : "";

/** Distinct values for entry_code, index_name, option_type, entry_type + column list. */
export const fetchFilters = async () => {
  const res = await axios.get(`${API_URL}api/entry-data-point-browser/filters`);
  return typeof res.data === "string" ? JSON.parse(res.data) : res.data;
};

/** Rows matching the current filters, projected in the column order. */
export const fetchRows = async ({
  entry_code = [],
  index_name = [],
  option_type = [],
  entry_type = [],
  date_from = null,
  date_to = null,
  limit = 500,
} = {}) => {
  const params = new URLSearchParams();
  entry_code.forEach(v => params.append("entry_code", v));
  index_name.forEach(v => params.append("index_name", v));
  option_type.forEach(v => params.append("option_type", v));
  entry_type.forEach(v => params.append("entry_type", v));
  if (date_from) params.set("date_from", date_from);
  if (date_to)   params.set("date_to",   date_to);
  params.set("limit", limit);
  const res = await axios.get(`${API_URL}api/entry-data-point-browser/data?${params.toString()}`);
  return typeof res.data === "string" ? JSON.parse(res.data) : res.data;
};
